/**
 * OpenRecordCardButton — ikonka „Otwórz kartę" przy polu wskazującym rekord innej kartoteki
 * (kontrahent, pracownik, użytkownik, firma, towar). Jeden klik otwiera kartę w NOWEJ
 * karcie powłoki — dokument zostaje w swojej (zgłoszenie ze szkolenia 14.10: w starym WF
 * dwuklik otwierał kartotekę, tu trzeba było wejść w edycję i okno wyboru).
 *
 * Działa także w trybie podglądu (nie zależy od `disabled` pola). Bez powłoki zakładek
 * (np. test bez TabProvider) albo dla kartoteki bez własnej trasy — nic nie renderuje.
 */

import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';

import { IconButton } from '@/components/IconButton';
import { useTabsOptional } from '@/contexts/TabContext';

/** Trasy kart w powłoce tenanta (TenantTabPanels) per slug kartoteki systemowej. */
const RECORD_CARD_ROUTES: Record<string, (id: string) => string> = {
  contractors: (id) => `/contractors/${id}`,
  employees: (id) => `/employees/${id}`,
  users: (id) => `/users/${id}`,
  companies: (id) => `/companies/${id}`,
  products: (id) => `/products/${id}`,
};

export function recordCardRoute(
  systemSlug: string | null | undefined,
  recordId: string | null | undefined,
): string | null {
  if (!systemSlug || !recordId) return null;
  const build = RECORD_CARD_ROUTES[systemSlug];
  return build ? build(recordId) : null;
}

export function OpenRecordCardButton({
  systemSlug,
  recordId,
  testId,
}: {
  systemSlug: string | null | undefined;
  recordId: string | null | undefined;
  testId?: string;
}) {
  const { t } = useTranslation();
  const tabs = useTabsOptional();
  const route = recordCardRoute(systemSlug, recordId);
  if (!tabs || !route) return null;
  return (
    <IconButton
      variant="ghost"
      size="sm"
      onClick={() => tabs.openTab(route)}
      aria-label={t('common.openRecordCard')}
      title={t('common.openRecordCard')}
      data-testid={testId}
    >
      <ExternalLink aria-hidden="true" />
    </IconButton>
  );
}
